/**
 * FieldDoc Krishi Kendra's custom surface components — the client half of the
 * agent's catalog (server half: `agent-dev-server/src/surfaces/`). Each entry
 * maps a `ComponentContract.component` name to its React realization.
 * `SurfaceRenderer` consults this before the platform builtin catalog.
 */
import type { FC } from 'react';
import type { A2uiNodeViewProps } from '@/app/lib/a2ui/catalog.tsx';
import { ClinicHome } from './ClinicHome.tsx';
import { DiagnosisCard } from './DiagnosisCard.tsx';
import { FieldTasks } from './FieldTasks.tsx';
import { InputCart } from './InputCart.tsx';
import { NextStep } from './NextStep.tsx';
import { NothingToBuy } from './NothingToBuy.tsx';
import { OrderConfirmation } from './OrderConfirmation.tsx';
import { SafetyStrip } from './SafetyStrip.tsx';
import { SeasonTimeline } from './SeasonTimeline.tsx';
import { SprayPlan } from './SprayPlan.tsx';
import { WeatherStrip } from './WeatherStrip.tsx';

export const AGENT_SURFACE_COMPONENTS: Record<string, FC<A2uiNodeViewProps>> = {
  ClinicHome,
  DiagnosisCard,
  WeatherStrip,
  SafetyStrip,
  SprayPlan,
  FieldTasks,
  SeasonTimeline,
  InputCart,
  OrderConfirmation,
  NothingToBuy,
  NextStep,
};
